import { MessageCircle } from "lucide-react";
import { useSite } from "@/lib/site-context";

export default function WhatsAppFloat() {
  const { site } = useSite();
  const wa = site?.whatsapp?.replace(/\D/g, "") || "";

  return (
    <a
      href={`https://wa.me/${wa}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-btn"
      className="hidden md:flex fixed bottom-8 right-6 z-40 items-center gap-2.5 bg-[#25D366] hover:bg-[#1EBE5D] text-white px-4 py-3 rounded-full shadow-xl hover:scale-105 transition-all font-semibold text-sm"
    >
      <MessageCircle className="w-4 h-4" /> Chat on WhatsApp
    </a>
  );
}
